import { noop } from "lodash-es";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";

export const useRecommendationsExperimentPageEvent = (recentlyViewedIds) => {
  const storePageEvent = useStorePageEvent();
  const isNewRecommendations = recentlyViewedIds?.length > 0;

  const getPageEventKey = (peType) => {
    switch (peType) {
      case PE_TYPE.LOADED: {
        return PE_KEYS.EXTENDED_CATEGORY_TO_CATEGORY_TLC_LOADED;
      }
      case PE_TYPE.CLICK:
      default: {
        return PE_KEYS.EXTENDED_CATEGORY_TO_CATEGORY_TLC_CLICK;
      }
    }
  };

  return isNewRecommendations
    ? {
        isUsingNewCategoryRecommendations: true,
        recommendationsPageEvent: (categoryId, itemCategoryId, index, pageEventType) => {
          storePageEvent(
            pageEventType,
            getPageEventKey(pageEventType),
            `carouselCategoryId=${categoryId}_categoryId=${itemCategoryId}_index=${index}`,
          );
        },
      }
    : {
        isUsingNewCategoryRecommendations: false,
        recommendationsPageEvent: noop,
      };
};
